var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"id":"ClaimSubmission","isLarge":true}},[_c('template',{slot:"title"},[_vm._v("Submitting Your Claim")]),_c('template',{slot:"body"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }